<!-- Change Password Modal  -->
<p-dialog [(visible)]="changePasswordModal" [resizable]="false" appendTo="body" [modal]="true"
  [breakpoints]="{'991px': '100vw'}" [style]="{width: '960px'}" styleClass="no-header-modal">

  <ng-template pTemplate="header" styleClass="hidden"></ng-template>
  <ng-template pTemplate="content" styleClass="p-0">


    <!-- Header -->
    <div class="flex align-items-center justify-content-between p-3 border-bottom-1 border-300">
      <div class="flex align-items-center">
        <h2 class="mb-0 text-sm">{{'CLIENT_CHANGE_PASSWORD.CHANGE_PASSWORD_FOR' | translate }} <strong>{{clientDetails.full_name}} </strong>
          <span class="text-xs text-600"> - {{clientDetails.id}}</span>
        </h2>
      </div>
      <div class="fa fa-times text-xl text-600 cursor-pointer" (click)="changePasswordModal = false"></div>
    </div>
    <!-- Header -->

    <form [formGroup]="resetForm" (ngSubmit)="ValidateAndSubmit(resetForm)">
    <!-- Content -->
    <div class="flex">
      
        <!-- Left Side-->
        <div class="border-right-1 border-300 lg:w-6 w-full">

          <!-- Modal Content -->
          <div class="py-2 md:py-4 px-3 md:px-5 surface-100">
            <!-- Column -->
            <div class="mb-3 md:mb-4 lg:w-11">
              <h4 class="font-medium text-700 text-xs mb-2 block uppercase">
                {{'CLIENT_CHANGE_PASSWORD.NEW_PASSWORD' | translate }}</h4>
              <p-password [toggleMask]="true" formControlName="new_password"
                [strongRegex]="'^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})'" styleClass="w-full p-input-icon-right">
              </p-password>
              <app-error-msg *ngIf="NewPassword.touched && NewPassword.invalid" [errors]="NewPassword.errors"
                [fieldLabel]="'STAFF.CHANGEPASSWORD.NEW_PASSWORD' | translate">
              </app-error-msg>

            </div>
            <!-- Column -->

            <!-- Column -->
            <div class="mb-3 md:mb-4 lg:w-11">
              <h4 class="font-medium text-700 text-xs mb-2 block uppercase">
                {{'CLIENT_CHANGE_PASSWORD.CONFIRM_NEW_PASSWORD' | translate }}</h4>
              <p-password [toggleMask]="true" formControlName="confirm_password"
                [strongRegex]="'^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})'" styleClass="w-full p-input-icon-right">
              </p-password>
              <app-error-msg *ngIf="NewConfirmPassword.touched && NewConfirmPassword.invalid"
                [errors]="NewConfirmPassword.errors"
                [fieldLabel]="'STAFF.CHANGEPASSWORD.NEW_CONFIRM_PASSWORD' | translate">
              </app-error-msg>
              <div class="required" class="p-error  text-xs mb-0"
                *ngIf="NewConfirmPassword.errors?.['confirmedValidator']">
                <div class="p-error mt-1 validationerror">
                  {{'common.errors.validations.PASSWORD_MISMATCH' | translate  }}
                </div>
              </div>
            </div>
            <!-- Column -->
          </div>
          <!-- Modal Content -->

          <!-- Password Rules -->
          <div class="lg:px-5 px-3 py-3 border-top-1 border-400 surface-0">
            <ul class="list-none text-sm p-0 m-0">
              <li class="flex align-items-center py-2">
                <span class="fa fa-check-square text-600 mr-3"></span>
                <span>{{'CLIENT_CHANGE_PASSWORD.CHARACTER_LONG' | translate }}</span>
              </li>
              <li class="flex align-items-center py-2">
                <span class="fa fa-check-square text-600 mr-3"></span>
                <span>{{'CLIENT_CHANGE_PASSWORD.ONE_LOWER_CASE' | translate }}</span>
              </li>
              <li class="flex align-items-center py-2">
                <span class="fa fa-check-square text-600 mr-3"></span>
                <span>{{'CLIENT_CHANGE_PASSWORD.ONE_UPPER_CASE' | translate }}</span>
              </li>
              <li class="flex align-items-center py-2">
                <span class="fa fa-check-square text-600 mr-3"></span>
                <span>{{'CLIENT_CHANGE_PASSWORD.OTHER_CASE' | translate }}</span>
              </li>
            </ul>
          </div>
          <!-- Password Rules -->


          <!-- Modal Footer -->
          <div class="lg:px-4 px-2 py-3 border-top-1 border-400 surface-0">
            <div class="flex align-items-center justify-content-between">
              <div class="w-4">
                <p-button [label]="'CLIENT_CHANGE_PASSWORD.CANCEL' | translate" styleClass="p-button-link text-sm"
                  (click)="changePasswordModal = false"> </p-button>
              </div>
              <div class="w-8 text-right">
                <p-button [label]="'CLIENT_CHANGE_PASSWORD.RESET_PASSWORD' | translate" type="submit" [loading]="btnLoading | async"  styleClass="text-sm"></p-button>
              </div>
            </div>
          </div>
          <!-- Modal Footer -->

        </div>
        <!-- Left Side -->
    
      <!-- Right Side -->
      <div class="pl-3 w-6 hidden lg:flex align-items-center justify-content-center p-3 text-right">
        <img src="/assets/img/change-pwd-img.svg" alt="Image" />
      </div>
      <!-- Right Side -->

    </div>
    <!-- Content -->

  </form>


  </ng-template>

</p-dialog>


<!-- Change Password Modal -->
